import axios from 'axios';
import * as environmentService from '../environment/environmentService';
import * as oauthService from '../oauth/oauthService';

const ApprovalService = {
    searchApprovals: (searchBody) => {
        return axios.post(`${environmentService.getVidCloudPrivUrl()}/approvaldocuments/searches/`, searchBody, oauthService.oauthHeaders());
    },

    getDocumentInfo: (approverGuid) => {
        return axios.get(`${environmentService.getVidCloudPrivUrl()}/approvaldocuments/${approverGuid}/documentinfo`, oauthService.oauthHeaders());
    },

    acceptApproval: (approverGuid, body) => {
        return axios.post(`${environmentService.getVidCloudPrivUrl()}/approvaldocuments/${approverGuid}/accepted/`, body, oauthService.oauthHeaders());
    },

    rejectApproval: (approverGuid, rejectBody) => {
        return axios.post(`${environmentService.getVidCloudPrivUrl()}/approvaldocuments/${approverGuid}/rejected`, rejectBody, oauthService.oauthHeaders());
    }
};

export default ApprovalService;

